import CryptoJS from "crypto-js"; // Use 'require' if in Node.js

const SECRET_KEY = "mySecretKey123"; // Store securely (e.g., env variable)

// Encrypt function: Supports strings, numbers, booleans, arrays, and objects
export const encrypt = (data) => {
  try {
    const jsonData = JSON.stringify(data); // Convert to string if needed
    return CryptoJS.AES.encrypt(jsonData, SECRET_KEY).toString();
  } catch (error) {
    console.error("Encryption Error:", error.message);
    return null;
  }
};

// Decrypt function: Converts back to original data type
export const decrypt = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedText); // Convert back to original type
  } catch (error) {
    console.error("Decryption Error:", error.message);
    return null;
  }
};
